import { baseQuerySetup,getResponsedata,onQueryStarted, onCacheEntryAdded } from 'config/index';
import { setNavLoader } from './App.service';
import { createApi } from '@reduxjs/toolkit/query/react';
import { mapResponseToDefaults } from 'utils/default-util';
import { current } from '@reduxjs/toolkit';
let consumerReducer = 'ConsumerReducer';
let consumerTag = 'ConsumerTag';

export const consumerApi = createApi({
    reducerPath: consumerReducer,
    baseQuery: baseQuerySetup,
    tagTypes: [consumerTag],
    endpoints: (builder) => ({
        getConsumers: builder.query({
            query: (params) => {
                const query = new URLSearchParams(params).toString();
                return { url: '/consumers?' + query , method: 'GET' };
            },
            onCacheEntryAdded,
            transformResponse: (response) => {
                if (response?.statusCode === 200 || response?.statusCode === 201) {
                    const data = response.result.data.map((row)=>{
                        return { ...row , txtcount: response.result?.txnsCountObj?.[row?._id] || 0 };
                    });
                    if (response.result.page === 1) {
                        return { ...response.result, data, initData: data };
                    } else {
                        return { ...response.result, data };
                    }
                }
                return response;
            },
            providesTags: [consumerTag]
        }),
        GetAllConsumers: builder.query({
            query: () => {
                return { url: '/exports/to-csv?resourceType=CONSUMER?' , method: 'GET' };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse: getResponsedata,
            providesTags: [consumerTag]

        }),
        getconsumerDetails: builder.query({
            query: ({ id }) => {
                return { url: '/consumers/' + id , method: 'GET' };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse: getResponsedata,
            providesTags: [consumerTag]

        }),
        UpdateConsumer: builder.mutation({
            query: ({ id , body }) => {
                return { url: '/consumers/' + id , body , method: 'PUT' };
            },
            async onQueryStarted({ id }, { dispatch , queryFulfilled }) {
                try {
                    dispatch(setNavLoader(true));
                    const { data } = await queryFulfilled;
                    dispatch(consumerApi.util.updateQueryData('getConsumerDetails',{ id } ,(draft) => {
                        Object.assign(draft , mapResponseToDefaults(current(draft),data));
                    }));
                    dispatch(setNavLoader(false));
                } catch (error) {
                    dispatch(setNavLoader(false));
                }
            },
            onCacheEntryAdded,
            transformResponse: getResponsedata
        }),
        SuspendToggleUser: builder.mutation({
            query: ({ id , body }) => {
                return { url: '/consumers/' + id + '/suspend-unsuspend', body , method: 'PUT' };
            },
            async onQueryStarted({ recentquery, id }, { dispatch , queryFulfilled }) {
                try {
                    dispatch(setNavLoader(true));
                    await queryFulfilled;
                    dispatch(consumerApi.util.updateQueryData('getConsumers',recentquery ,(draft) => {
                        let record = draft.data.find((row)=> row._id === id);
                        record.isSuspendedByAdmin = !record?.isSuspendedByAdmin;
                    }));
                    dispatch(setNavLoader(false));
                } catch (error) {
                    dispatch(setNavLoader(false));
                }
            },

            onCacheEntryAdded,
            transformResponse: getResponsedata
        })

    })
});
export const { useLazyGetConsumersQuery, useGetAllConsumersQuery, useGetConsumersQuery , useGetconsumerDetailsQuery,useSuspendToggleUserMutation, useUpdateConsumerMutation } = consumerApi;
